module.exports = __webpack_public_path__ + "FSAlbert-Italic.411b89a26011c9741ed4.otf";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fsAlbert/FSAlbert-Italic.otf
// module id = ../../../../../src/assets/fonts/fsAlbert/FSAlbert-Italic.otf
// module chunks = main